import { render } from "./TColorInput.vue?vue&type=template&id=784828b6&scoped=true"
import script from "./TColorInput.vue?vue&type=script&lang=js"
export * from "./TColorInput.vue?vue&type=script&lang=js"

import "./TColorInput.vue?vue&type=style&index=0&id=784828b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784828b6"]])

export default __exports__